export default __webpack_public_path__ + "f814b30bc1c8e7bb911f7fffaeff1bae.png";